<template>
  <div>
    <header-unauthenticated />
    <div class="container">
      <div class="login login--header-padding">
        <img src="@/assets/superliga/logo-3x.png" alt="" class="login__logo" v-if="$config.MODE == 'SUPERLIGA'">
        <img src="@/assets/logo.svg" alt="" class="login__logo" v-else>
        <div class="form-group">
          <input 
          type="email"
          v-model.trim="$v.userModel.username.$model"
          :class="{'has-error': $v.userModel.username.$error && $v.userModel.username.$invalid, 'with-value': $v.userModel.username.$model != ''}"
          :id="$t('login.form.email')" class="form-control" required>
          <label class="form-control-placeholder" :for="$t('login.form.email')">{{$t('login.form.email')}}</label>
        </div>
        <div class="form-group">
          <input 
            type="password" 
            v-model.trim="$v.userModel.password.$model"
            :class="{'has-error': $v.userModel.password.$error && $v.userModel.password.$invalid, 'with-value': $v.userModel.password.$model != ''}"
            :id="$t('login.form.password')" class="form-control" required>
          <label class="form-control-placeholder" :for="$t('login.form.password')">{{$t('login.form.password')}}</label>
        </div>
        <router-link to="/recoverPassword" class="login__recover">
          {{$t('login.recoveryPassword')}}
        </router-link>

        <button class="button button--white" @click.prevent="login()" :disabled="$v.userModel.$invalid || submitted">
          <template v-if="!submitted">
            {{$t('login.login')}}
          </template>
          <template v-else>
            {{$t('login.loading')}} <div class="loading-points"><span>.</span><span>.</span><span>.</span></div>
          </template>
        </button>
        <router-link to="/register">
          <button class="button button--clean">{{$t('login.createAccount')}}</button>
        </router-link>
        <img src="@/assets/logo.svg" alt="" class="login__logo-footer" v-if="$config.MODE == 'SUPERLIGA'">
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import PersistentData from '@/plugins/persistentData'
import HeaderUnauthenticated from '@/components/Header/Unauthenticated.vue'

export default {
  components: {
    HeaderUnauthenticated
  },
  data() {
    return {
      userModel: {
        username: "",
        password: ""
      },
      submitted: false
    }
  },
  methods: {
    async login() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.submitted = true
        const request = await this.$store.dispatch("authenticate", this.userModel)
        if (request == undefined) this.submitted = false
        if (request.status == 200) {
          PersistentData.setData('fullName', `${request.data.firstName} ${request.data.lastName}`)
          PersistentData.setData('token', request.data.token)
          PersistentData.setData('tokenExpiration', request.data.tokenExpiration)
          const profile = await this.$store.dispatch("profileGet")
          if (profile.data.birthDate == null && profile.data.team == null) {
            this.$router.push('/login/onboarding')
          } else {
            this.$router.push('/home/games')
          }
        }
      }
    }
  },
  validations: {
    userModel: {
      username: {
        required
      },
      password: {
        required
      }
    }
  }
}
</script>

<style lang="scss">
  @import '@/styles/_variables';
  
  .login {

    &__recover {
      color: $white!important;
      @include font-settings(xmilli, base);
      text-transform: uppercase;
      font-family: $font-barlow;
      font-weight: 600;
      padding-left: $margin-base;
      padding-top: $margin-milli / 2;
    }
  }
</style>